<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="6">
        <b-card :header="$t('Country Details')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="cnt">
            <FloatingLabel v-model="details.name" label="Name" size="sm" />
            <FloatingLabel v-model="details.iso2" label="ISO2" size="sm" />
            <FloatingLabel v-model="details.iso3" label="ISO3" size="sm" />

            <FloatingLabel
              v-if="details.flag_file"
              :value="details.flag_file"
              label="Flag"
              type="plain"
              size="sm"
            />
            <FloatingLabel v-else :value="details.iso2" label="Flag" type="flag" size="sm" />

            <FloatingLabel v-model.number="details.priority" label="Priority" size="sm" />
            <b-form-group :label="$t('Is Active')" class="grouping py-2 px-3 mb-3 mt-0">
              <b-form-checkbox
                v-model="details.active"
                :value="true"
                :unchecked-value="false"
              >{{$t('Is country active')}}</b-form-checkbox>
            </b-form-group>

            <div style="text-align:right">
              <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col cols="12" md="6" v-if="eid">
        <b-card :header="$t('Upload Flag File')" style="position:relative">
          <b-form @submit.prevent="onSubmitFile" autocomplete="off" ref="upd">
            <b-form-file
              v-model="file"
              :placeholder="$t('Choose a flag image...')"
              :drop-placeholder="$t('Drop flag image here...')"
              class="mb-3"
            ></b-form-file>

            <div style="text-align:right">
              <b-button
                type="submit"
                variant="success"
                :disabled="!file && !details.iso2"
              >{{$t('Upload')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";

export default {
  name: "country",
  props: ["selectedeid"],
  components: {
    FloatingLabel
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    if (this.eid != "0" && this.eid != "") {
      this.loadData();
    } else {
      this.newId = true;
    }
  },
  data: function() {
    return {
      eid: "",
      file: null,
      details: {
        name: "",
        iso2: "",
        iso3: "",
        priority: 100,
        active: true,
        flag_file: ""
      },
      newId: false
    };
  },
  computed: {
    flag() {
      return this.details.iso2;
    }
  },
  methods: {
    loadData() {
      if (this.eid == "") return;

      const loadDet = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("country/read", this.eid)
        .then(resp => {
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    onSubmitDetails() {
      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "country/update";
      if (this.newId) {
        apiAction = "country/create";
      } else {
        detailsData.eid = this.eid;
      }
      if (detailsData.priority != "") {
        detailsData.priority = parseInt(detailsData.priority);
      } else {
        delete detailsData.priority;
      }

      delete detailsData.flag_file;

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Country updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Country created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },
    onSubmitFile() {
      const loader = this.$loading.open({
        container: this.$refs.upd
      });
      if (this.eid && this.file) {
        let formData = new FormData();
        formData.append("uploadfile", this.file, this.file.name);
        formData.append("country_id", this.eid);
        this.$store
          .dispatch("country/uploadFile", formData)
          .then(resp => {
            let msg = "Country flag updated";
            this.file = null;
            this.details.flag_file = "/upload/" + this.details.iso2;
            this.showSuccessNotification(msg);
          })
          .catch(err => {
            this.showErrorNotification(err);
          })
          .finally(() => {
            loader.close();
          });
      }
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      this.details.name = r.name;
      this.details.iso2 = r.iso2;
      this.details.iso3 = r.iso3;
      if (typeof r.priority != "undefined") {
        this.details.priority = r.priority;
      }
      if (typeof r.active != "undefined") {
        this.details.active = r.active;
      }
      this.details.flag_file = r.flag_file;
    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Country", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
